import { useKeyContext } from './KeyContextProvider'

export * from './KeyContextProvider'

export default useKeyContext
